module.exports = __webpack_public_path__ + "static/img/6.25115fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/6.png
// module id = yG/I
// module chunks = 45